import { createContext } from "react";

export const DiscoveryModeContext = createContext({
  organizations: [],
  setOrganizations: () => {},
  selectedOrganizations: [],
  setSelectedOrganizations: () => {},
  selectedLabels: [],
  setSelectedLabels: () => {},
  selectedArtists: [],
  setSelectedArtists: () => {},
  selectedRecordings: [],
  setSelectedRecordings: () => {},
  selectedReleases: [],
  setSelectedReleases: () => {},
  labels: [],
  setLabels: () => {},
  artists: [],
  setArtists: () => {},
  recordings: [],
  setRecordings: () => {},
  releases: [],
  setReleases: () => {},
  stage: 'END',
  setStage: () => {},
  endDataAvailable: false,
  setEndDataAvailable: () => {},
  midDataAvailable: null,
  setMidDataAvailable: () => {}
})